import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  IconButton
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { formatDate } from "./regrasFaturamentoUtils";

const getNomeById = (options, id) => {
  if (id === null || id === undefined || id === '') return 'Não informado';
  const item = options?.find(o => String(o.id) === String(id));
  return item?.name || String(id);
};

// Filtra a mensagem da API: remove linhas com IDs e mantém intro + sugestão
const formatarMensagemConflito = (message, temConflitos) => {
  if (!message) return [];
  const linhas = message.split('\n');
  if (!temConflitos) return linhas;

  const ignorar = /^-\s+(Unidade ID|Forma de Cobrança ID|Cirurgião ID|BPL ID|Vigência):/i;
  const resultado = [];
  let pularBlocoRegra = false;

  for (const linha of linhas) {
    if (linha.trim() === 'Regra conflitante:') {
      pularBlocoRegra = true;
      continue;
    }
    if (pularBlocoRegra) {
      if (linha.startsWith('Sugestão:')) {
        pularBlocoRegra = false;
        resultado.push(linha);
      } else if (!ignorar.test(linha.trim()) && linha.trim() !== '') {
        pularBlocoRegra = false;
        resultado.push(linha);
      }
      continue;
    }
    if (!ignorar.test(linha.trim())) {
      resultado.push(linha);
    }
  }
  return resultado.filter(l => l.trim() !== '');
};

const ConflictDialog = ({ conflictError, onClose, unidadesOptions = [], formasCobrancaOptions = [], cirurgioesOptions = [] }) => {
  const temConflitos = conflictError?.conflitos?.length > 0;
  const linhasMensagem = formatarMensagemConflito(conflictError?.message, temConflitos);

  return (
  <Dialog open={!!conflictError} onClose={onClose} maxWidth="sm" fullWidth>
    <DialogTitle style={{ color: "#d32f2f", display: 'flex', alignItems: 'center', gap: 8 }}>
      <span style={{ flex: 1 }}>Conflito de Regra de Faturamento</span>
      <IconButton size="small" onClick={onClose} aria-label="close">
        <CloseIcon fontSize="small" />
      </IconButton>
    </DialogTitle>
    <DialogContent style={{ paddingTop: 16 }}>
      {linhasMensagem.length > 0 && (
        <div style={{ marginBottom: 16 }}>
          {linhasMensagem.map((line, i) => (
            <p key={i} style={{ margin: '2px 0', fontSize: 14, color: '#333' }}>
              {line}
            </p>
          ))}
        </div>
      )}
      {conflictError?.conflitos?.length > 0 && (
        <div style={{
          background: '#fff3e0',
          border: '1px solid #ffb74d',
          borderRadius: 6,
          padding: '12px 16px',
          marginTop: 8
        }}>
          <p style={{ margin: '0 0 8px', fontWeight: 600, fontSize: 13, color: '#e65100' }}>
            Regra(s) conflitante(s):
          </p>
          {conflictError.conflitos.map((c, i) => (
            <div key={i} style={{
              background: '#fff',
              border: '1px solid #ffe0b2',
              borderRadius: 4,
              padding: '8px 12px',
              marginTop: i > 0 ? 8 : 0,
              fontSize: 13,
              lineHeight: 1.7,
              color: '#444'
            }}>
              <div><strong>Unidade:</strong> {getNomeById(unidadesOptions, c.Unidade)}</div>
              <div><strong>Forma de Cobrança:</strong> {getNomeById(formasCobrancaOptions, c.FormaCobranca)}</div>
              <div><strong>Cirurgião:</strong> {getNomeById(cirurgioesOptions, c.Cirurgiao)}</div>
              <div><strong>BPL ID:</strong> {c.BPLID}</div>
              <div><strong>Início:</strong> {formatDate(c.StartDate)}</div>
              <div><strong>Fim:</strong> {c.EndDate ? formatDate(c.EndDate) : 'INDEFINIDO'}</div>
            </div>
          ))}
        </div>
      )}
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} color="primary" variant="contained">
        Entendi
      </Button>
    </DialogActions>
  </Dialog>
  );
};

export default ConflictDialog;
